import {
  footballPlayerAnimationName,
  playersSkinName,
  playersSkinNames,
} from '../footballCore/constants';
import { soundService } from '../../../services/baseSoundService/soundService';
import { FootballSoundsName } from '../footballCore/constants/sounds';

class FootballDrawerService {
  constructor() {
    this.currentPlayerSkeletonIndex = 0;
  }

  setPlayerSpine(playerSpine) {
    this.playerSpine = playerSpine;
    this.setSkeletonToSpine(this.playerSpine, playersSkinName.player1);
  }

  playerIdleAnimation() {
    this.playerSpine.state.clearTracks();
    this.playerSpine.skeleton.setToSetupPose();
    this.playerSpine.play(footballPlayerAnimationName.idle, true);
  }

  playerFirstAnimation() {
    this.playerSpine.state.clearTracks();
    this.playerSpine.skeleton.setToSetupPose();
    this.playerSpine.play(footballPlayerAnimationName.animation1, true);
    this.playerSpine.addListener(
      'kick',
      () => {
        soundService.play(FootballSoundsName.kick);
      },
      this.playerSpine,
      footballPlayerAnimationName.animation1
    );
  }

  playerSecondAnimation() {
    this.playerSpine.play(footballPlayerAnimationName.animation2, true);
  }

  playerFallAnimation(callBack = () => {}) {
    this.playerSpine.state.clearTracks();
    this.playerSpine.skeleton.setToSetupPose();
    this.playerSpine.play(footballPlayerAnimationName.fall);
    this.playerSpine.addListener(
      'complete',
      callBack,
      this.playerSpine,
      footballPlayerAnimationName.fall,
      true
    );
  }

  resetAnimations() {
    this.playerSpine.state.clearTracks();
    this.playerSpine.skeleton.setToSetupPose();
  }

  setSkeletonToSpine(spine, skeletonType) {
    spine.skeleton.setSkinByName(skeletonType);
  }

  changePlayerSkeleton(isNext) {
    soundService.play(FootballSoundsName.bet);
    this.currentPlayerSkeletonIndex += isNext ? 1 : -1;
    if (this.currentPlayerSkeletonIndex >= playersSkinNames.length) {
      this.currentPlayerSkeletonIndex = 0;
    } else if (this.currentPlayerSkeletonIndex < 0) {
      this.currentPlayerSkeletonIndex = playersSkinNames.length - 1;
    }
    this.setSkeletonToSpine(this.playerSpine, playersSkinNames[this.currentPlayerSkeletonIndex]);
    this.playerSpine.state.clearTracks();
    this.playerSpine.skeleton.setToSetupPose();
    this.playerIdleAnimation();
  }
}

export const footballDrawerService = new FootballDrawerService();
